import { observable, computed, action } from "mobx";
import axios from "axios";
import { ISingleApp } from "../models/index";

const FILOINK_APPID = "000000";

class QueryStore {
  @observable public apps: [ISingleApp] = [
    { appName: "飞洛印", appId: "000000" },
  ];
  @observable public queryDetail = {};
  @observable public hashChainDetail = {};
  @observable public hashCheckCompleted = false;
  @observable public chooseAppId: string;
  @observable public confirmationType: string;

  @computed get defaultChooseApp() {
    return this.apps.filter((app) => app.appId === FILOINK_APPID)[0];
  }

  @action public async getApps() {
    const { data } = await axios.get("/v1/check/apps");
    this.setAppData(data.data);
    return data.data;
  }

  @action public setAppData(apps: [ISingleApp]) {
    this.apps = apps;
    this.chooseAppId = this.apps.filter(
      (app) => app.appId === FILOINK_APPID
    )[0].appId;
  }

  @action public setChooseAppId(appId: string) {
    this.chooseAppId = appId;
  }

  @action public async doHashCheck(content: string, appId?: string) {
    !!appId && (this.chooseAppId = appId);
    const { data } = await axios.post(
      `/v1/check/txhash?appId=${this.chooseAppId}&content=${content}`
    );
    if (data.code === 0) {
      this.hashChainDetail = data.data;
      this.hashCheckCompleted = true;
    }
    return data;
  }

  @action public async doContentQuery(
    eviHash: string,
    extractionCode: string,
    appId?: string
  ) {
    !!appId && (this.chooseAppId = appId);
    const { data } = await axios.post(
      `/v1/check?appId=${this.chooseAppId}&eviHash=${eviHash}&extractionCode=${extractionCode}`
    );
    if (data.code === 0) {
      this.queryDetail = data.data;
    }
    return data;
  }
  @action public async doNewContentQuery(
    confirmationNo: string,
    platform: number
  ) {
    const { data } = await axios.get(
      `/api/cfmt/v1/confirmation/info?confirmationNo=${confirmationNo}&platform=${platform}`
    );
    if (data.code === 0) {
      this.queryDetail = data.data;
      this.confirmationType = data.data.confirmationType;
    }
    return data;
  }
}

export default QueryStore;



// WEBPACK FOOTER //
// ./src/stores/QueryStore.ts